import React, { memo } from "react";
import PropTypes from "prop-types";

const radioWithLabel = ({
  inputClassName,
  labelClassName,
  label,
  checked,
  onChange,
  name,
  value,
  disabled,
  onClick,
  readOnly,
}) => {
  const inputId = `${name}_${label}`;
  return (
    <>
      <input
        type="radio"
        className={inputClassName}
        id={inputId}
        onClick={onClick}
        name={name}
        readOnly={readOnly}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        value={value}
      />
      <label className={labelClassName} htmlFor={inputId}>
        {label}
      </label>
    </>
  );
};

radioWithLabel.propTypes = {
  inputClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  label: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};

export default memo(radioWithLabel);
